import { CheckCircle2 } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHero } from "@/pages/About";
import { Reveal } from "@/components/Reveal";
import { ValuationFullForm } from "@/components/LeadForms";
import { useLanguage } from "@/context/LanguageContext";

export default function Valuation() {
  const { t } = useLanguage();
  return (
    <main data-testid="valuation-page">
      <Seo
        title="Home Valuation — What Is Your Miami Home Worth? | Carlos Vindel Realty"
        siteName="Carlos Vindel Realty"
        description="Get a free, data-backed home valuation for your South Florida property. Personalized Comparative Market Analysis prepared by Carlos Vindel within 24 hours."
      />
      <PageHero testid="valuation-hero" overline={t.valuationPage.overline} title={t.valuationPage.title} subtitle={t.valuationPage.subtitle} />

      <section className="bg-cream py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-5 gap-14">
          <div className="lg:col-span-2">
            <Reveal>
              <ul className="space-y-6">
                {[t.valuationPage.trust1, t.valuationPage.trust2, t.valuationPage.trust3].map((item, i) => (
                  <li key={i} data-testid={`valuation-trust-${i}`} className="flex items-start gap-4">
                    <CheckCircle2 className="w-5 h-5 text-gold shrink-0 mt-0.5" />
                    <span className="text-[#525D6B] leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-12 border-l-2 border-gold pl-6">
                <p className="font-serif italic text-xl text-ink leading-relaxed">
                  {t.hero.line1} {t.hero.line2}
                </p>
                <p className="mt-2 font-serif italic text-xl text-gold">{t.hero.line3}</p>
              </div>
            </Reveal>
          </div>
          <Reveal delay={0.1} className="lg:col-span-3 bg-white border border-sand/80 p-7 sm:p-10 shadow-[0_8px_40px_rgba(13,19,26,0.06)]">
            <ValuationFullForm />
          </Reveal>
        </div>
      </section>
    </main>
  );
}
